module.exports = __webpack_public_path__ + "img/second_.2472b975.jpg";